import { metrics } from '@atlassian/browser-metrics';
import type { Metric } from '@atlassian/browser-metrics/types';

export const branchDetailsPopupLoad: Metric = metrics.interaction({
	key: 'board.branch-details-popup-load',
});

export const commitDetailsPopupLoad: Metric = metrics.interaction({
	key: 'board.commit-details-popup-load',
});

export const deploymentDetailsPopupLoad: Metric = metrics.interaction({
	key: 'board.deployment-details-popup-load',
});

export const prDetailsPopupLoad: Metric = metrics.interaction({
	key: 'board.pr-details-popup-load',
});

export const designDetailsPopupLoad: Metric = metrics.interaction({
	key: 'board.design-details-popup-load',
});
